export * as actions from "./actions";
export { default as reducer } from "./reducer";
export const initialState = null;
